/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * B2B Backend API
 * API documentation for B2B Platform
 * OpenAPI spec version: 1.0.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query'
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query'
import type {
  AwardBadgeRequest,
  CompanyBadgeAward,
  CompanyBadgePanel,
  CompanyVerificationOverview,
  EvidenceFact,
  ModeratorsVerificationDocumentsRetrieveParams,
  ModeratorsVerificationRegistrationsRetrieveParams,
  ModeratorsVerificationShareholdersRetrieveParams,
  ModeratorsVerificationShareholdersVerifyCreateBody,
  PaginatedModeratorDocument,
  PaginatedModeratorRegistration,
  PaginatedModeratorShareholder,
  PaginatedVerificationCheck,
  PaginatedVerificationQueueRow,
  PatchedVerificationBadgeRequest,
  RevokeAwardRequest,
  VerificationBadge,
  VerificationBadgeRequest,
  VerificationCheck,
  VerificationConfirmRequest,
  VerificationDismissRequest,
  VerificationHit,
  VerificationHitDecisionRequest,
  VerificationModeratorChecksListParams,
  VerificationModeratorCompaniesListParams,
  VerificationModeratorProvidersListParams,
  VerificationMonitoring,
  VerificationMonitoringToggleRequest,
  VerificationProviderList,
  VerificationSelectCandidateRequest,
  VerificationStartRequest,
  _ModeratorDocument,
  _ModeratorRegistration,
  _ModeratorShareholder
} from '.././model'
import { customInstance } from '../../../../api/client';



/**
 * Cross-company moderation queue.

Lets moderators see and act on every pending document, entity registration,
and shareholder identification in one place — without having to drill into
each company individually.
 * @summary Approve document
 */
export const moderatorsVerificationDocumentsApproveCreate = (
    id: number,
 ) => {
      
      
      return customInstance<_ModeratorDocument>(
      {url: `/api/v1/moderators/verification/${id}/documents/approve/`, method: 'POST'
    },
      );
    }
  


export const getModeratorsVerificationDocumentsApproveCreateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof moderatorsVerificationDocumentsApproveCreate>>, TError,{id: number}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof moderatorsVerificationDocumentsApproveCreate>>, TError,{id: number}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof moderatorsVerificationDocumentsApproveCreate>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  moderatorsVerificationDocumentsApproveCreate(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ModeratorsVerificationDocumentsApproveCreateMutationResult = NonNullable<Awaited<ReturnType<typeof moderatorsVerificationDocumentsApproveCreate>>>
    
    export type ModeratorsVerificationDocumentsApproveCreateMutationError = void

    /**
 * @summary Approve document
 */
export const useModeratorsVerificationDocumentsApproveCreate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof moderatorsVerificationDocumentsApproveCreate>>, TError,{id: number}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof moderatorsVerificationDocumentsApproveCreate>>,
        TError,
        {id: number},
        TContext
      > => {

      const mutationOptions = getModeratorsVerificationDocumentsApproveCreateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Cross-company moderation queue.

Lets moderators see and act on every pending document, entity registration,
and shareholder identification in one place — without having to drill into
each company individually.
 * @summary Reject document
 */
export const moderatorsVerificationDocumentsRejectCreate = (
    id: number,
 ) => {
      
      
      return customInstance<_ModeratorDocument>(
      {url: `/api/v1/moderators/verification/${id}/documents/reject/`, method: 'POST'
    },
      );
    }
  


export const getModeratorsVerificationDocumentsRejectCreateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof moderatorsVerificationDocumentsRejectCreate>>, TError,{id: number}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof moderatorsVerificationDocumentsRejectCreate>>, TError,{id: number}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof moderatorsVerificationDocumentsRejectCreate>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  moderatorsVerificationDocumentsRejectCreate(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ModeratorsVerificationDocumentsRejectCreateMutationResult = NonNullable<Awaited<ReturnType<typeof moderatorsVerificationDocumentsRejectCreate>>>
    
    export type ModeratorsVerificationDocumentsRejectCreateMutationError = void

    /**
 * @summary Reject document
 */
export const useModeratorsVerificationDocumentsRejectCreate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof moderatorsVerificationDocumentsRejectCreate>>, TError,{id: number}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof moderatorsVerificationDocumentsRejectCreate>>,
        TError,
        {id: number},
        TContext
      > => {

      const mutationOptions = getModeratorsVerificationDocumentsRejectCreateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Cross-company moderation queue.

Lets moderators see and act on every pending document, entity registration,
and shareholder identification in one place — without having to drill into
each company individually.
 * @summary Approve entity registration
 */
export const moderatorsVerificationRegistrationsApproveCreate = (
    id: number,
 ) => {
      
      
      return customInstance<_ModeratorRegistration>(
      {url: `/api/v1/moderators/verification/${id}/registrations/approve/`, method: 'POST'
    },
      );
    }
  


export const getModeratorsVerificationRegistrationsApproveCreateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof moderatorsVerificationRegistrationsApproveCreate>>, TError,{id: number}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof moderatorsVerificationRegistrationsApproveCreate>>, TError,{id: number}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof moderatorsVerificationRegistrationsApproveCreate>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  moderatorsVerificationRegistrationsApproveCreate(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ModeratorsVerificationRegistrationsApproveCreateMutationResult = NonNullable<Awaited<ReturnType<typeof moderatorsVerificationRegistrationsApproveCreate>>>
    
    export type ModeratorsVerificationRegistrationsApproveCreateMutationError = void

    /**
 * @summary Approve entity registration
 */
export const useModeratorsVerificationRegistrationsApproveCreate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof moderatorsVerificationRegistrationsApproveCreate>>, TError,{id: number}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof moderatorsVerificationRegistrationsApproveCreate>>,
        TError,
        {id: number},
        TContext
      > => {

      const mutationOptions = getModeratorsVerificationRegistrationsApproveCreateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Cross-company moderation queue.

Lets moderators see and act on every pending document, entity registration,
and shareholder identification in one place — without having to drill into
each company individually.
 * @summary Mark entity registration inactive
 */
export const moderatorsVerificationRegistrationsRejectCreate = (
    id: number,
 ) => {
      
      
      return customInstance<_ModeratorRegistration>(
      {url: `/api/v1/moderators/verification/${id}/registrations/reject/`, method: 'POST'
    },
      );
    }
  


export const getModeratorsVerificationRegistrationsRejectCreateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof moderatorsVerificationRegistrationsRejectCreate>>, TError,{id: number}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof moderatorsVerificationRegistrationsRejectCreate>>, TError,{id: number}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof moderatorsVerificationRegistrationsRejectCreate>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  moderatorsVerificationRegistrationsRejectCreate(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ModeratorsVerificationRegistrationsRejectCreateMutationResult = NonNullable<Awaited<ReturnType<typeof moderatorsVerificationRegistrationsRejectCreate>>>
    
    export type ModeratorsVerificationRegistrationsRejectCreateMutationError = void

    /**
 * @summary Mark entity registration inactive
 */
export const useModeratorsVerificationRegistrationsRejectCreate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof moderatorsVerificationRegistrationsRejectCreate>>, TError,{id: number}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof moderatorsVerificationRegistrationsRejectCreate>>,
        TError,
        {id: number},
        TContext
      > => {

      const mutationOptions = getModeratorsVerificationRegistrationsRejectCreateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Cross-company moderation queue.

Lets moderators see and act on every pending document, entity registration,
and shareholder identification in one place — without having to drill into
each company individually.
 * @summary Mark shareholder ID-verified
 */
export const moderatorsVerificationShareholdersVerifyCreate = (
    id: number,
    moderatorsVerificationShareholdersVerifyCreateBody: ModeratorsVerificationShareholdersVerifyCreateBody,
 ) => {
      
      
      return customInstance<_ModeratorShareholder>(
      {url: `/api/v1/moderators/verification/${id}/shareholders/verify/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: moderatorsVerificationShareholdersVerifyCreateBody
    },
      );
    }
  


export const getModeratorsVerificationShareholdersVerifyCreateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof moderatorsVerificationShareholdersVerifyCreate>>, TError,{id: number;data: ModeratorsVerificationShareholdersVerifyCreateBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof moderatorsVerificationShareholdersVerifyCreate>>, TError,{id: number;data: ModeratorsVerificationShareholdersVerifyCreateBody}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof moderatorsVerificationShareholdersVerifyCreate>>, {id: number;data: ModeratorsVerificationShareholdersVerifyCreateBody}> = (props) => {
          const {id,data} = props ?? {};

          return  moderatorsVerificationShareholdersVerifyCreate(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ModeratorsVerificationShareholdersVerifyCreateMutationResult = NonNullable<Awaited<ReturnType<typeof moderatorsVerificationShareholdersVerifyCreate>>>
    export type ModeratorsVerificationShareholdersVerifyCreateMutationBody = ModeratorsVerificationShareholdersVerifyCreateBody
    export type ModeratorsVerificationShareholdersVerifyCreateMutationError = void

    /**
 * @summary Mark shareholder ID-verified
 */
export const useModeratorsVerificationShareholdersVerifyCreate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof moderatorsVerificationShareholdersVerifyCreate>>, TError,{id: number;data: ModeratorsVerificationShareholdersVerifyCreateBody}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof moderatorsVerificationShareholdersVerifyCreate>>,
        TError,
        {id: number;data: ModeratorsVerificationShareholdersVerifyCreateBody},
        TContext
      > => {

      const mutationOptions = getModeratorsVerificationShareholdersVerifyCreateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Optional `status` filter (defaults to `pending`).
 * @summary List documents pending review
 */
export const moderatorsVerificationDocumentsRetrieve = (
    params?: ModeratorsVerificationDocumentsRetrieveParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<PaginatedModeratorDocument>(
      {url: `/api/v1/moderators/verification/documents/`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getModeratorsVerificationDocumentsRetrieveQueryKey = (params?: ModeratorsVerificationDocumentsRetrieveParams,) => {
    return [`/api/v1/moderators/verification/documents/`, ...(params ? [params]: [])] as const;
    }

    
export const getModeratorsVerificationDocumentsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof moderatorsVerificationDocumentsRetrieve>>, TError = unknown>(params?: ModeratorsVerificationDocumentsRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof moderatorsVerificationDocumentsRetrieve>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getModeratorsVerificationDocumentsRetrieveQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof moderatorsVerificationDocumentsRetrieve>>> = ({ signal }) => moderatorsVerificationDocumentsRetrieve(params, signal);

      

      

   return  { queryKey, queryFn,   staleTime: 30000, gcTime: 300000, refetchOnMount: true,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof moderatorsVerificationDocumentsRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type ModeratorsVerificationDocumentsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof moderatorsVerificationDocumentsRetrieve>>>
export type ModeratorsVerificationDocumentsRetrieveQueryError = unknown

/**
 * @summary List documents pending review
 */
export const useModeratorsVerificationDocumentsRetrieve = <TData = Awaited<ReturnType<typeof moderatorsVerificationDocumentsRetrieve>>, TError = unknown>(
 params?: ModeratorsVerificationDocumentsRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof moderatorsVerificationDocumentsRetrieve>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getModeratorsVerificationDocumentsRetrieveQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Cross-company moderation queue.

Lets moderators see and act on every pending document, entity registration,
and shareholder identification in one place — without having to drill into
each company individually.
 * @summary List entity registrations pending review
 */
export const moderatorsVerificationRegistrationsRetrieve = (
    params?: ModeratorsVerificationRegistrationsRetrieveParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<PaginatedModeratorRegistration>(
      {url: `/api/v1/moderators/verification/registrations/`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getModeratorsVerificationRegistrationsRetrieveQueryKey = (params?: ModeratorsVerificationRegistrationsRetrieveParams,) => {
    return [`/api/v1/moderators/verification/registrations/`, ...(params ? [params]: [])] as const;
    }

    
export const getModeratorsVerificationRegistrationsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof moderatorsVerificationRegistrationsRetrieve>>, TError = unknown>(params?: ModeratorsVerificationRegistrationsRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof moderatorsVerificationRegistrationsRetrieve>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getModeratorsVerificationRegistrationsRetrieveQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof moderatorsVerificationRegistrationsRetrieve>>> = ({ signal }) => moderatorsVerificationRegistrationsRetrieve(params, signal);

      

      

   return  { queryKey, queryFn,   staleTime: 30000, gcTime: 300000, refetchOnMount: true,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof moderatorsVerificationRegistrationsRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type ModeratorsVerificationRegistrationsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof moderatorsVerificationRegistrationsRetrieve>>>
export type ModeratorsVerificationRegistrationsRetrieveQueryError = unknown

/**
 * @summary List entity registrations pending review
 */
export const useModeratorsVerificationRegistrationsRetrieve = <TData = Awaited<ReturnType<typeof moderatorsVerificationRegistrationsRetrieve>>, TError = unknown>(
 params?: ModeratorsVerificationRegistrationsRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof moderatorsVerificationRegistrationsRetrieve>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getModeratorsVerificationRegistrationsRetrieveQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Cross-company moderation queue.

Lets moderators see and act on every pending document, entity registration,
and shareholder identification in one place — without having to drill into
each company individually.
 * @summary List shareholders pending verification
 */
export const moderatorsVerificationShareholdersRetrieve = (
    params?: ModeratorsVerificationShareholdersRetrieveParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<PaginatedModeratorShareholder>(
      {url: `/api/v1/moderators/verification/shareholders/`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getModeratorsVerificationShareholdersRetrieveQueryKey = (params?: ModeratorsVerificationShareholdersRetrieveParams,) => {
    return [`/api/v1/moderators/verification/shareholders/`, ...(params ? [params]: [])] as const;
    }

    
export const getModeratorsVerificationShareholdersRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof moderatorsVerificationShareholdersRetrieve>>, TError = unknown>(params?: ModeratorsVerificationShareholdersRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof moderatorsVerificationShareholdersRetrieve>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getModeratorsVerificationShareholdersRetrieveQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof moderatorsVerificationShareholdersRetrieve>>> = ({ signal }) => moderatorsVerificationShareholdersRetrieve(params, signal);

      

      

   return  { queryKey, queryFn,   staleTime: 30000, gcTime: 300000, refetchOnMount: true,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof moderatorsVerificationShareholdersRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type ModeratorsVerificationShareholdersRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof moderatorsVerificationShareholdersRetrieve>>>
export type ModeratorsVerificationShareholdersRetrieveQueryError = unknown

/**
 * @summary List shareholders pending verification
 */
export const useModeratorsVerificationShareholdersRetrieve = <TData = Awaited<ReturnType<typeof moderatorsVerificationShareholdersRetrieve>>, TError = unknown>(
 params?: ModeratorsVerificationShareholdersRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof moderatorsVerificationShareholdersRetrieve>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getModeratorsVerificationShareholdersRetrieveQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * The award stays in the history, marked revoked.
 * @summary Revoke a badge award (moderator)
 */
export const verificationModeratorAwardsRevokeCreate = (
    id: number,
    revokeAwardRequest: RevokeAwardRequest,
 ) => {
      
      
      return customInstance<CompanyBadgeAward>(
      {url: `/api/v1/verification/moderator/awards/${id}/revoke/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: revokeAwardRequest
    },
      );
    }
  


export const getVerificationModeratorAwardsRevokeCreateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof verificationModeratorAwardsRevokeCreate>>, TError,{id: number;data: RevokeAwardRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof verificationModeratorAwardsRevokeCreate>>, TError,{id: number;data: RevokeAwardRequest}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof verificationModeratorAwardsRevokeCreate>>, {id: number;data: RevokeAwardRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  verificationModeratorAwardsRevokeCreate(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type VerificationModeratorAwardsRevokeCreateMutationResult = NonNullable<Awaited<ReturnType<typeof verificationModeratorAwardsRevokeCreate>>>
    export type VerificationModeratorAwardsRevokeCreateMutationBody = RevokeAwardRequest
    export type VerificationModeratorAwardsRevokeCreateMutationError = void

    /**
 * @summary Revoke a badge award (moderator)
 */
export const useVerificationModeratorAwardsRevokeCreate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof verificationModeratorAwardsRevokeCreate>>, TError,{id: number;data: RevokeAwardRequest}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof verificationModeratorAwardsRevokeCreate>>,
        TError,
        {id: number;data: RevokeAwardRequest},
        TContext
      > => {

      const mutationOptions = getVerificationModeratorAwardsRevokeCreateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Badge types are data: any moderator reads them, super moderators
create and edit them (also in Django admin).
 * @summary List badges (moderator)
 */
export const verificationModeratorBadgesList = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<VerificationBadge[]>(
      {url: `/api/v1/verification/moderator/badges/`, method: 'GET', signal
    },
      );
    }
  

export const getVerificationModeratorBadgesListQueryKey = () => {
    return [`/api/v1/verification/moderator/badges/`] as const;
    }

    
export const getVerificationModeratorBadgesListQueryOptions = <TData = Awaited<ReturnType<typeof verificationModeratorBadgesList>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof verificationModeratorBadgesList>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getVerificationModeratorBadgesListQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof verificationModeratorBadgesList>>> = ({ signal }) => verificationModeratorBadgesList(signal);

      

      

   return  { queryKey, queryFn,   staleTime: 30000, gcTime: 300000, refetchOnMount: true,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof verificationModeratorBadgesList>>, TError, TData> & { queryKey: QueryKey }
}

export type VerificationModeratorBadgesListQueryResult = NonNullable<Awaited<ReturnType<typeof verificationModeratorBadgesList>>>
export type VerificationModeratorBadgesListQueryError = unknown

/**
 * @summary List badges (moderator)
 */
export const useVerificationModeratorBadgesList = <TData = Awaited<ReturnType<typeof verificationModeratorBadgesList>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof verificationModeratorBadgesList>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getVerificationModeratorBadgesListQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Badge types are data: any moderator reads them, super moderators
create and edit them (also in Django admin).
 * @summary Create a badge (super moderator)
 */
export const verificationModeratorBadgesCreate = (
    verificationBadgeRequest: VerificationBadgeRequest,
 ) => {
      
      
      return customInstance<VerificationBadge>(
      {url: `/api/v1/verification/moderator/badges/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: verificationBadgeRequest
    },
      );
    }
  


export const getVerificationModeratorBadgesCreateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof verificationModeratorBadgesCreate>>, TError,{data: VerificationBadgeRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof verificationModeratorBadgesCreate>>, TError,{data: VerificationBadgeRequest}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof verificationModeratorBadgesCreate>>, {data: VerificationBadgeRequest}> = (props) => {
          const {data} = props ?? {};

          return  verificationModeratorBadgesCreate(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type VerificationModeratorBadgesCreateMutationResult = NonNullable<Awaited<ReturnType<typeof verificationModeratorBadgesCreate>>>
    export type VerificationModeratorBadgesCreateMutationBody = VerificationBadgeRequest
    export type VerificationModeratorBadgesCreateMutationError = void

    /**
 * @summary Create a badge (super moderator)
 */
export const useVerificationModeratorBadgesCreate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof verificationModeratorBadgesCreate>>, TError,{data: VerificationBadgeRequest}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof verificationModeratorBadgesCreate>>,
        TError,
        {data: VerificationBadgeRequest},
        TContext
      > => {

      const mutationOptions = getVerificationModeratorBadgesCreateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Badge types are data: any moderator reads them, super moderators
create and edit them (also in Django admin).
 * @summary Get a badge (moderator)
 */
export const verificationModeratorBadgesRetrieve = (
    id: number,
 signal?: AbortSignal
) => {
      
      
      return customInstance<VerificationBadge>(
      {url: `/api/v1/verification/moderator/badges/${id}/`, method: 'GET', signal
    },
      );
    }
  

export const getVerificationModeratorBadgesRetrieveQueryKey = (id: number,) => {
    return [`/api/v1/verification/moderator/badges/${id}/`] as const;
    }

    
export const getVerificationModeratorBadgesRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof verificationModeratorBadgesRetrieve>>, TError = void>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof verificationModeratorBadgesRetrieve>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getVerificationModeratorBadgesRetrieveQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof verificationModeratorBadgesRetrieve>>> = ({ signal }) => verificationModeratorBadgesRetrieve(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id),  staleTime: 30000, gcTime: 300000, refetchOnMount: true,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof verificationModeratorBadgesRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type VerificationModeratorBadgesRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof verificationModeratorBadgesRetrieve>>>
export type VerificationModeratorBadgesRetrieveQueryError = void

/**
 * @summary Get a badge (moderator)
 */
export const useVerificationModeratorBadgesRetrieve = <TData = Awaited<ReturnType<typeof verificationModeratorBadgesRetrieve>>, TError = void>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof verificationModeratorBadgesRetrieve>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getVerificationModeratorBadgesRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Label, description, rank, required evidence and `isActive` may change at any time; awards already made then follow the new required evidence. `key` is fixed once the badge was awarded.
 * @summary Edit a badge (super moderator)
 */
export const verificationModeratorBadgesPartialUpdate = (
    id: number,
    patchedVerificationBadgeRequest: PatchedVerificationBadgeRequest,
 ) => {
      
      
      return customInstance<VerificationBadge>(
      {url: `/api/v1/verification/moderator/badges/${id}/`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: patchedVerificationBadgeRequest
    },
      );
    }
  


export const getVerificationModeratorBadgesPartialUpdateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof verificationModeratorBadgesPartialUpdate>>, TError,{id: number;data: PatchedVerificationBadgeRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof verificationModeratorBadgesPartialUpdate>>, TError,{id: number;data: PatchedVerificationBadgeRequest}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof verificationModeratorBadgesPartialUpdate>>, {id: number;data: PatchedVerificationBadgeRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  verificationModeratorBadgesPartialUpdate(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type VerificationModeratorBadgesPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof verificationModeratorBadgesPartialUpdate>>>
    export type VerificationModeratorBadgesPartialUpdateMutationBody = PatchedVerificationBadgeRequest
    export type VerificationModeratorBadgesPartialUpdateMutationError = void

    /**
 * @summary Edit a badge (super moderator)
 */
export const useVerificationModeratorBadgesPartialUpdate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof verificationModeratorBadgesPartialUpdate>>, TError,{id: number;data: PatchedVerificationBadgeRequest}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof verificationModeratorBadgesPartialUpdate>>,
        TError,
        {id: number;data: PatchedVerificationBadgeRequest},
        TContext
      > => {

      const mutationOptions = getVerificationModeratorBadgesPartialUpdateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * A badge with awards can only be deactivated (`isActive`).
 * @summary Delete a never-awarded badge (super moderator)
 */
export const verificationModeratorBadgesDestroy = (
    id: number,
 ) => {
      
      
      return customInstance<void>(
      {url: `/api/v1/verification/moderator/badges/${id}/`, method: 'DELETE'
    },
      );
    }
  


export const getVerificationModeratorBadgesDestroyMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof verificationModeratorBadgesDestroy>>, TError,{id: number}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof verificationModeratorBadgesDestroy>>, TError,{id: number}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof verificationModeratorBadgesDestroy>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  verificationModeratorBadgesDestroy(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type VerificationModeratorBadgesDestroyMutationResult = NonNullable<Awaited<ReturnType<typeof verificationModeratorBadgesDestroy>>>
    
    export type VerificationModeratorBadgesDestroyMutationError = void

    /**
 * @summary Delete a never-awarded badge (super moderator)
 */
export const useVerificationModeratorBadgesDestroy = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof verificationModeratorBadgesDestroy>>, TError,{id: number}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof verificationModeratorBadgesDestroy>>,
        TError,
        {id: number},
        TContext
      > => {

      const mutationOptions = getVerificationModeratorBadgesDestroyMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Badge types are data: any moderator reads them, super moderators
create and edit them (also in Django admin).
 * @summary Evidence facts a badge can require (moderator)
 */
export const verificationModeratorBadgesFactsList = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<EvidenceFact[]>(
      {url: `/api/v1/verification/moderator/badges/facts/`, method: 'GET', signal
    },
      );
    }
  

export const getVerificationModeratorBadgesFactsListQueryKey = () => {
    return [`/api/v1/verification/moderator/badges/facts/`] as const;
    }

    
export const getVerificationModeratorBadgesFactsListQueryOptions = <TData = Awaited<ReturnType<typeof verificationModeratorBadgesFactsList>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof verificationModeratorBadgesFactsList>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getVerificationModeratorBadgesFactsListQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof verificationModeratorBadgesFactsList>>> = ({ signal }) => verificationModeratorBadgesFactsList(signal);

      

      

   return  { queryKey, queryFn,   staleTime: 30000, gcTime: 300000, refetchOnMount: true,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof verificationModeratorBadgesFactsList>>, TError, TData> & { queryKey: QueryKey }
}

export type VerificationModeratorBadgesFactsListQueryResult = NonNullable<Awaited<ReturnType<typeof verificationModeratorBadgesFactsList>>>
export type VerificationModeratorBadgesFactsListQueryError = unknown

/**
 * @summary Evidence facts a badge can require (moderator)
 */
export const useVerificationModeratorBadgesFactsList = <TData = Awaited<ReturnType<typeof verificationModeratorBadgesFactsList>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof verificationModeratorBadgesFactsList>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getVerificationModeratorBadgesFactsListQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Checks queue + per-check actions.
 * @summary List provider checks (moderator)
 */
export const verificationModeratorChecksList = (
    params?: VerificationModeratorChecksListParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<PaginatedVerificationCheck[]>(
      {url: `/api/v1/verification/moderator/checks/`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getVerificationModeratorChecksListQueryKey = (params?: VerificationModeratorChecksListParams,) => {
    return [`/api/v1/verification/moderator/checks/`, ...(params ? [params]: [])] as const;
    }

    
export const getVerificationModeratorChecksListQueryOptions = <TData = Awaited<ReturnType<typeof verificationModeratorChecksList>>, TError = unknown>(params?: VerificationModeratorChecksListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof verificationModeratorChecksList>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getVerificationModeratorChecksListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof verificationModeratorChecksList>>> = ({ signal }) => verificationModeratorChecksList(params, signal);

      

      

   return  { queryKey, queryFn,   staleTime: 30000, gcTime: 300000, refetchOnMount: true,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof verificationModeratorChecksList>>, TError, TData> & { queryKey: QueryKey }
}

export type VerificationModeratorChecksListQueryResult = NonNullable<Awaited<ReturnType<typeof verificationModeratorChecksList>>>
export type VerificationModeratorChecksListQueryError = unknown

/**
 * @summary List provider checks (moderator)
 */
export const useVerificationModeratorChecksList = <TData = Awaited<ReturnType<typeof verificationModeratorChecksList>>, TError = unknown>(
 params?: VerificationModeratorChecksListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof verificationModeratorChecksList>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getVerificationModeratorChecksListQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Every hit must be decided first. Applies the chosen proposed fields (all when `fields` is omitted) and records their source. Never approves the company itself.
 * @summary Confirm a check and apply proposed values (super moderator)
 */
export const verificationModeratorChecksConfirmCreate = (
    id: number,
    verificationConfirmRequest: VerificationConfirmRequest,
 ) => {
      
      
      return customInstance<VerificationCheck>(
      {url: `/api/v1/verification/moderator/checks/${id}/confirm/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: verificationConfirmRequest
    },
      );
    }
  


export const getVerificationModeratorChecksConfirmCreateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof verificationModeratorChecksConfirmCreate>>, TError,{id: number;data: VerificationConfirmRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof verificationModeratorChecksConfirmCreate>>, TError,{id: number;data: VerificationConfirmRequest}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof verificationModeratorChecksConfirmCreate>>, {id: number;data: VerificationConfirmRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  verificationModeratorChecksConfirmCreate(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type VerificationModeratorChecksConfirmCreateMutationResult = NonNullable<Awaited<ReturnType<typeof verificationModeratorChecksConfirmCreate>>>
    export type VerificationModeratorChecksConfirmCreateMutationBody = VerificationConfirmRequest
    export type VerificationModeratorChecksConfirmCreateMutationError = void

    /**
 * @summary Confirm a check and apply proposed values (super moderator)
 */
export const useVerificationModeratorChecksConfirmCreate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof verificationModeratorChecksConfirmCreate>>, TError,{id: number;data: VerificationConfirmRequest}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof verificationModeratorChecksConfirmCreate>>,
        TError,
        {id: number;data: VerificationConfirmRequest},
        TContext
      > => {

      const mutationOptions = getVerificationModeratorChecksConfirmCreateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Checks queue + per-check actions.
 * @summary Dismiss a check without applying it (super moderator)
 */
export const verificationModeratorChecksDismissCreate = (
    id: number,
    verificationDismissRequest: VerificationDismissRequest,
 ) => {
      
      
      return customInstance<VerificationCheck>(
      {url: `/api/v1/verification/moderator/checks/${id}/dismiss/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: verificationDismissRequest
    },
      );
    }
  


export const getVerificationModeratorChecksDismissCreateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof verificationModeratorChecksDismissCreate>>, TError,{id: number;data: VerificationDismissRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof verificationModeratorChecksDismissCreate>>, TError,{id: number;data: VerificationDismissRequest}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof verificationModeratorChecksDismissCreate>>, {id: number;data: VerificationDismissRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  verificationModeratorChecksDismissCreate(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type VerificationModeratorChecksDismissCreateMutationResult = NonNullable<Awaited<ReturnType<typeof verificationModeratorChecksDismissCreate>>>
    export type VerificationModeratorChecksDismissCreateMutationBody = VerificationDismissRequest
    export type VerificationModeratorChecksDismissCreateMutationError = void

    /**
 * @summary Dismiss a check without applying it (super moderator)
 */
export const useVerificationModeratorChecksDismissCreate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof verificationModeratorChecksDismissCreate>>, TError,{id: number;data: VerificationDismissRequest}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof verificationModeratorChecksDismissCreate>>,
        TError,
        {id: number;data: VerificationDismissRequest},
        TContext
      > => {

      const mutationOptions = getVerificationModeratorChecksDismissCreateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Checks queue + per-check actions.
 * @summary Poll the provider for a running check (moderator)
 */
export const verificationModeratorChecksRefreshCreate = (
    id: number,
 ) => {
      
      
      return customInstance<VerificationCheck>(
      {url: `/api/v1/verification/moderator/checks/${id}/refresh/`, method: 'POST'
    },
      );
    }
  


export const getVerificationModeratorChecksRefreshCreateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof verificationModeratorChecksRefreshCreate>>, TError,{id: number}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof verificationModeratorChecksRefreshCreate>>, TError,{id: number}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof verificationModeratorChecksRefreshCreate>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  verificationModeratorChecksRefreshCreate(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type VerificationModeratorChecksRefreshCreateMutationResult = NonNullable<Awaited<ReturnType<typeof verificationModeratorChecksRefreshCreate>>>
    
    export type VerificationModeratorChecksRefreshCreateMutationError = void

    /**
 * @summary Poll the provider for a running check (moderator)
 */
export const useVerificationModeratorChecksRefreshCreate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof verificationModeratorChecksRefreshCreate>>, TError,{id: number}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof verificationModeratorChecksRefreshCreate>>,
        TError,
        {id: number},
        TContext
      > => {

      const mutationOptions = getVerificationModeratorChecksRefreshCreateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * For a `needs_selection` check: the registry search returned several companies. Choose one by `candidateId`; the provider then fetches its profile (and screens it, where offered). If none is right, dismiss the check instead.
 * @summary Pick the registry company to continue with (moderator)
 */
export const verificationModeratorChecksSelectCandidateCreate = (
    id: number,
    verificationSelectCandidateRequest: VerificationSelectCandidateRequest,
 ) => {
      
      
      return customInstance<VerificationCheck>(
      {url: `/api/v1/verification/moderator/checks/${id}/selectCandidate/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: verificationSelectCandidateRequest
    },
      );
    }
  


export const getVerificationModeratorChecksSelectCandidateCreateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof verificationModeratorChecksSelectCandidateCreate>>, TError,{id: number;data: VerificationSelectCandidateRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof verificationModeratorChecksSelectCandidateCreate>>, TError,{id: number;data: VerificationSelectCandidateRequest}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof verificationModeratorChecksSelectCandidateCreate>>, {id: number;data: VerificationSelectCandidateRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  verificationModeratorChecksSelectCandidateCreate(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type VerificationModeratorChecksSelectCandidateCreateMutationResult = NonNullable<Awaited<ReturnType<typeof verificationModeratorChecksSelectCandidateCreate>>>
    export type VerificationModeratorChecksSelectCandidateCreateMutationBody = VerificationSelectCandidateRequest
    export type VerificationModeratorChecksSelectCandidateCreateMutationError = void

    /**
 * @summary Pick the registry company to continue with (moderator)
 */
export const useVerificationModeratorChecksSelectCandidateCreate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof verificationModeratorChecksSelectCandidateCreate>>, TError,{id: number;data: VerificationSelectCandidateRequest}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof verificationModeratorChecksSelectCandidateCreate>>,
        TError,
        {id: number;data: VerificationSelectCandidateRequest},
        TContext
      > => {

      const mutationOptions = getVerificationModeratorChecksSelectCandidateCreateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Every company (except flagged ones) with its verification state: `needs_check` (never checked, rejected, dismissed, failed or only partly verified), `in_progress`, `awaiting_decision`, `awaiting_badge` (the evidence supports a stronger badge than the public one) or `verified`; its verdict, public and suggested badge, current evidence, registrations, open checks, last decision and the recommended provider.
 * @summary Verification queue (moderator)
 */
export const verificationModeratorCompaniesList = (
    params?: VerificationModeratorCompaniesListParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<PaginatedVerificationQueueRow[]>(
      {url: `/api/v1/verification/moderator/companies/`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getVerificationModeratorCompaniesListQueryKey = (params?: VerificationModeratorCompaniesListParams,) => {
    return [`/api/v1/verification/moderator/companies/`, ...(params ? [params]: [])] as const;
    }

    
export const getVerificationModeratorCompaniesListQueryOptions = <TData = Awaited<ReturnType<typeof verificationModeratorCompaniesList>>, TError = unknown>(params?: VerificationModeratorCompaniesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof verificationModeratorCompaniesList>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getVerificationModeratorCompaniesListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof verificationModeratorCompaniesList>>> = ({ signal }) => verificationModeratorCompaniesList(params, signal);

      

      

   return  { queryKey, queryFn,   staleTime: 30000, gcTime: 300000, refetchOnMount: true,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof verificationModeratorCompaniesList>>, TError, TData> & { queryKey: QueryKey }
}

export type VerificationModeratorCompaniesListQueryResult = NonNullable<Awaited<ReturnType<typeof verificationModeratorCompaniesList>>>
export type VerificationModeratorCompaniesListQueryError = unknown

/**
 * @summary Verification queue (moderator)
 */
export const useVerificationModeratorCompaniesList = <TData = Awaited<ReturnType<typeof verificationModeratorCompaniesList>>, TError = unknown>(
 params?: VerificationModeratorCompaniesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof verificationModeratorCompaniesList>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getVerificationModeratorCompaniesListQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Provider checks (history, status, cost, hits, proposed values), current compliance values with their source (provider / manual), monitoring status and the per-company budget.
 * @summary Company verification overview (moderator)
 */
export const verificationModeratorCompaniesRetrieve = (
    id: number,
 signal?: AbortSignal
) => {
      
      
      return customInstance<CompanyVerificationOverview>(
      {url: `/api/v1/verification/moderator/companies/${id}/`, method: 'GET', signal
    },
      );
    }
  

export const getVerificationModeratorCompaniesRetrieveQueryKey = (id: number,) => {
    return [`/api/v1/verification/moderator/companies/${id}/`] as const;
    }

    
export const getVerificationModeratorCompaniesRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof verificationModeratorCompaniesRetrieve>>, TError = void>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof verificationModeratorCompaniesRetrieve>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getVerificationModeratorCompaniesRetrieveQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof verificationModeratorCompaniesRetrieve>>> = ({ signal }) => verificationModeratorCompaniesRetrieve(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id),  staleTime: 30000, gcTime: 300000, refetchOnMount: true,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof verificationModeratorCompaniesRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type VerificationModeratorCompaniesRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof verificationModeratorCompaniesRetrieve>>>
export type VerificationModeratorCompaniesRetrieveQueryError = void

/**
 * @summary Company verification overview (moderator)
 */
export const useVerificationModeratorCompaniesRetrieve = <TData = Awaited<ReturnType<typeof verificationModeratorCompaniesRetrieve>>, TError = void>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof verificationModeratorCompaniesRetrieve>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getVerificationModeratorCompaniesRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Any moderator may award an active badge whose required evidence holds now. Otherwise 400 with `code: evidence_missing` and the `missingEvidence` list; a super moderator may then award it with an `overrideReason` (403 for other moderators). The award is valid until `validUntil` (default VERIFICATION_BADGE_VALIDITY_DAYS) and pauses while its evidence doesn't hold, unless overridden. Returns the updated badge panel.
 * @summary Award a badge to a company (moderator)
 */
export const verificationModeratorCompaniesAwardBadgeCreate = (
    id: number,
    awardBadgeRequest: AwardBadgeRequest,
 ) => {
      
      
      return customInstance<CompanyBadgePanel>(
      {url: `/api/v1/verification/moderator/companies/${id}/awardBadge/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: awardBadgeRequest
    },
      );
    }
  


export const getVerificationModeratorCompaniesAwardBadgeCreateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof verificationModeratorCompaniesAwardBadgeCreate>>, TError,{id: number;data: AwardBadgeRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof verificationModeratorCompaniesAwardBadgeCreate>>, TError,{id: number;data: AwardBadgeRequest}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof verificationModeratorCompaniesAwardBadgeCreate>>, {id: number;data: AwardBadgeRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  verificationModeratorCompaniesAwardBadgeCreate(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type VerificationModeratorCompaniesAwardBadgeCreateMutationResult = NonNullable<Awaited<ReturnType<typeof verificationModeratorCompaniesAwardBadgeCreate>>>
    export type VerificationModeratorCompaniesAwardBadgeCreateMutationBody = AwardBadgeRequest
    export type VerificationModeratorCompaniesAwardBadgeCreateMutationError = void

    /**
 * @summary Award a badge to a company (moderator)
 */
export const useVerificationModeratorCompaniesAwardBadgeCreate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof verificationModeratorCompaniesAwardBadgeCreate>>, TError,{id: number;data: AwardBadgeRequest}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof verificationModeratorCompaniesAwardBadgeCreate>>,
        TError,
        {id: number;data: AwardBadgeRequest},
        TContext
      > => {

      const mutationOptions = getVerificationModeratorCompaniesAwardBadgeCreateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * The company's verdict (verified | pending | rejected | expired | none), the award behind its public badge, the evidence facts that hold now, the suggested (strongest supported) badge, every badge with its missing evidence, and the award history with each award's state (active | paused | expired | revoked).
 * @summary Badges, evidence and verdict for a company (moderator)
 */
export const verificationModeratorCompaniesBadgesRetrieve = (
    id: number,
 signal?: AbortSignal
) => {
      
      
      return customInstance<CompanyBadgePanel>(
      {url: `/api/v1/verification/moderator/companies/${id}/badges/`, method: 'GET', signal
    },
      );
    }
  

export const getVerificationModeratorCompaniesBadgesRetrieveQueryKey = (id: number,) => {
    return [`/api/v1/verification/moderator/companies/${id}/badges/`] as const;
    }

    
export const getVerificationModeratorCompaniesBadgesRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof verificationModeratorCompaniesBadgesRetrieve>>, TError = void>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof verificationModeratorCompaniesBadgesRetrieve>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getVerificationModeratorCompaniesBadgesRetrieveQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof verificationModeratorCompaniesBadgesRetrieve>>> = ({ signal }) => verificationModeratorCompaniesBadgesRetrieve(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id),  staleTime: 30000, gcTime: 300000, refetchOnMount: true,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof verificationModeratorCompaniesBadgesRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type VerificationModeratorCompaniesBadgesRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof verificationModeratorCompaniesBadgesRetrieve>>>
export type VerificationModeratorCompaniesBadgesRetrieveQueryError = void

/**
 * @summary Badges, evidence and verdict for a company (moderator)
 */
export const useVerificationModeratorCompaniesBadgesRetrieve = <TData = Awaited<ReturnType<typeof verificationModeratorCompaniesBadgesRetrieve>>, TError = void>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof verificationModeratorCompaniesBadgesRetrieve>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getVerificationModeratorCompaniesBadgesRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Per-company verification overview, start a check, monitoring.
 * @summary Turn ongoing monitoring on/off (super moderator)
 */
export const verificationModeratorCompaniesMonitoringCreate = (
    id: number,
    verificationMonitoringToggleRequest: VerificationMonitoringToggleRequest,
 ) => {
      
      
      return customInstance<VerificationMonitoring>(
      {url: `/api/v1/verification/moderator/companies/${id}/monitoring/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: verificationMonitoringToggleRequest
    },
      );
    }
  


export const getVerificationModeratorCompaniesMonitoringCreateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof verificationModeratorCompaniesMonitoringCreate>>, TError,{id: number;data: VerificationMonitoringToggleRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof verificationModeratorCompaniesMonitoringCreate>>, TError,{id: number;data: VerificationMonitoringToggleRequest}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof verificationModeratorCompaniesMonitoringCreate>>, {id: number;data: VerificationMonitoringToggleRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  verificationModeratorCompaniesMonitoringCreate(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type VerificationModeratorCompaniesMonitoringCreateMutationResult = NonNullable<Awaited<ReturnType<typeof verificationModeratorCompaniesMonitoringCreate>>>
    export type VerificationModeratorCompaniesMonitoringCreateMutationBody = VerificationMonitoringToggleRequest
    export type VerificationModeratorCompaniesMonitoringCreateMutationError = void

    /**
 * @summary Turn ongoing monitoring on/off (super moderator)
 */
export const useVerificationModeratorCompaniesMonitoringCreate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof verificationModeratorCompaniesMonitoringCreate>>, TError,{id: number;data: VerificationMonitoringToggleRequest}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof verificationModeratorCompaniesMonitoringCreate>>,
        TError,
        {id: number;data: VerificationMonitoringToggleRequest},
        TContext
      > => {

      const mutationOptions = getVerificationModeratorCompaniesMonitoringCreateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Runs the chosen provider (default VERIFICATION_PROVIDER) on one of the company's registrations, in the background: registry lookup and, where the provider offers it, screening of the company and its shareholders. Idempotent per provider: while a check with that provider is open or awaiting a decision, the existing one is returned (200).
 * @summary Start a provider verification check (moderator)
 */
export const verificationModeratorCompaniesStartCreate = (
    id: number,
    verificationStartRequest: VerificationStartRequest,
 ) => {
      
      
      return customInstance<VerificationCheck>(
      {url: `/api/v1/verification/moderator/companies/${id}/start/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: verificationStartRequest
    },
      );
    }
  


export const getVerificationModeratorCompaniesStartCreateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof verificationModeratorCompaniesStartCreate>>, TError,{id: number;data: VerificationStartRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof verificationModeratorCompaniesStartCreate>>, TError,{id: number;data: VerificationStartRequest}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof verificationModeratorCompaniesStartCreate>>, {id: number;data: VerificationStartRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  verificationModeratorCompaniesStartCreate(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type VerificationModeratorCompaniesStartCreateMutationResult = NonNullable<Awaited<ReturnType<typeof verificationModeratorCompaniesStartCreate>>>
    export type VerificationModeratorCompaniesStartCreateMutationBody = VerificationStartRequest
    export type VerificationModeratorCompaniesStartCreateMutationError = void

    /**
 * @summary Start a provider verification check (moderator)
 */
export const useVerificationModeratorCompaniesStartCreate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof verificationModeratorCompaniesStartCreate>>, TError,{id: number;data: VerificationStartRequest}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof verificationModeratorCompaniesStartCreate>>,
        TError,
        {id: number;data: VerificationStartRequest},
        TContext
      > => {

      const mutationOptions = getVerificationModeratorCompaniesStartCreateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * @summary Confirm or dismiss a screening hit (super moderator)
 */
export const verificationModeratorHitsDecideCreate = (
    id: number,
    verificationHitDecisionRequest: VerificationHitDecisionRequest,
 ) => {
      
      
      return customInstance<VerificationHit>(
      {url: `/api/v1/verification/moderator/hits/${id}/decide/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: verificationHitDecisionRequest
    },
      );
    }
  


export const getVerificationModeratorHitsDecideCreateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof verificationModeratorHitsDecideCreate>>, TError,{id: number;data: VerificationHitDecisionRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof verificationModeratorHitsDecideCreate>>, TError,{id: number;data: VerificationHitDecisionRequest}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof verificationModeratorHitsDecideCreate>>, {id: number;data: VerificationHitDecisionRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  verificationModeratorHitsDecideCreate(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type VerificationModeratorHitsDecideCreateMutationResult = NonNullable<Awaited<ReturnType<typeof verificationModeratorHitsDecideCreate>>>
    export type VerificationModeratorHitsDecideCreateMutationBody = VerificationHitDecisionRequest
    export type VerificationModeratorHitsDecideCreateMutationError = void

    /**
 * @summary Confirm or dismiss a screening hit (super moderator)
 */
export const useVerificationModeratorHitsDecideCreate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof verificationModeratorHitsDecideCreate>>, TError,{id: number;data: VerificationHitDecisionRequest}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof verificationModeratorHitsDecideCreate>>,
        TError,
        {id: number;data: VerificationHitDecisionRequest},
        TContext
      > => {

      const mutationOptions = getVerificationModeratorHitsDecideCreateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Every provider with its jurisdictions, use cases, benchmark scores and cost note; `integrated` / `configured` say whether it can be run. With `company` (and optionally `registration`), providers get a `recommendedRank` from the routing table for that registration's jurisdiction, and `openCheckId` when the company already has an open check with them. Recommendations only: any configured provider may be run.
 * @summary List verification providers (moderator)
 */
export const verificationModeratorProvidersList = (
    params?: VerificationModeratorProvidersListParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<VerificationProviderList[]>(
      {url: `/api/v1/verification/moderator/providers/`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getVerificationModeratorProvidersListQueryKey = (params?: VerificationModeratorProvidersListParams,) => {
    return [`/api/v1/verification/moderator/providers/`, ...(params ? [params]: [])] as const;
    }

    
export const getVerificationModeratorProvidersListQueryOptions = <TData = Awaited<ReturnType<typeof verificationModeratorProvidersList>>, TError = void>(params?: VerificationModeratorProvidersListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof verificationModeratorProvidersList>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getVerificationModeratorProvidersListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof verificationModeratorProvidersList>>> = ({ signal }) => verificationModeratorProvidersList(params, signal);

      

      

   return  { queryKey, queryFn,   staleTime: 30000, gcTime: 300000, refetchOnMount: true,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof verificationModeratorProvidersList>>, TError, TData> & { queryKey: QueryKey }
}

export type VerificationModeratorProvidersListQueryResult = NonNullable<Awaited<ReturnType<typeof verificationModeratorProvidersList>>>
export type VerificationModeratorProvidersListQueryError = void

/**
 * @summary List verification providers (moderator)
 */
export const useVerificationModeratorProvidersList = <TData = Awaited<ReturnType<typeof verificationModeratorProvidersList>>, TError = void>(
 params?: VerificationModeratorProvidersListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof verificationModeratorProvidersList>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getVerificationModeratorProvidersListQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



